import DashboardContent from './dashboardContent';

export default DashboardContent;